module.exports = require("dns");


//////////////////
// WEBPACK FOOTER
// external "dns"
// module id = 155
// module chunks = 0